import React from 'react';
import { useSelector } from 'react-redux';

import { getLanguage } from '@travel/i18n';
import { InfoOutline } from '@travel/icons/ui';
import { useTranslation } from '@travel/traveler-core/hooks';
import { IconText } from '@travel/ui';

import { Translate } from 'core/translate';

type Props = {
  /** Optional className for styling */
  className?: string;
  /** Optional className for text styling */
  textClassName?: string;
};

function ResultDisclaimer({ className, textClassName }: Props) {
  const language = useSelector(getLanguage);
  const linkLabel = useTranslation({ id: 'Provider_List.Recommendation.Title' });

  // Language-specific FAQ detail IDs
  const languageDetailMap: Record<string, string> = {
    'en-us': '000040488',
    'ko-kr': '000040489',
    'zh-tw': '000040490',
    'zh-cn': '000040491',
    'vi-vn': '000040492',
    'th-th': '000040493',
    'id-id': '000040494',
    'zh-hk': '000040495',
  };

  // Get the detail ID for the current language, fallback to English if not found
  const detailId = languageDetailMap[language.toLowerCase()] || languageDetailMap['en-us'];
  const disclaimerUrl = `https://travel.faq.rakuten.net/${language.toLowerCase()}/s/detail/${detailId}`;

  return (
    <a
      href={disclaimerUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label={linkLabel}
      data-testid="result-disclaimer-link"
    >
      <IconText
        className={textClassName}
        icon={<InfoOutline size={16} color="sonicSilver" />}
        spaceBetween={4}
        text={<Translate id="Provider_List.Recommendation.Title" />}
      />
    </a>
  );
}

export default ResultDisclaimer;
